<ng-container [formGroup]="fg">
    @if (!readOnly && (Features.PlanningSaveSortSave | hasFeature)) {
        <td class="drag-handle" cdkDragHandle>
            <i class="fa fa-arrows-from-line"></i>
        </td>
    }
    @if (
        (pln.entitytype?.has_lowloader || pln.entitytype?.has_truck || pln.entitytype?.has_driver) &&
        pln.entity?.use_once
    ) {
        <td
            [class.error-background]="fg.controls.driver_user_id.invalid"
            [class.alert-multiple]="pln.driver_user_id | multipleDriver: pln : main.planning : planning">
            <div class="d-flex">
                <ng-select
                    class="ng-dropdown-panel-left"
                    [preventToggleOnRightClick]="true"
                    [items]="drivers"
                    [formControl]="fg.controls.driver_user_id"
                    [style.width.px]="150"
                    placeholder="Chauffeur"
                    bindLabel="name"
                    bindValue="id">
                    <ng-template ng-label-tmp ng-option-tmp let-item="item" let-index="index">
                        @if (leaveDayUserMap.has(item.id)) {
                            <i
                                class="fa-solid {{ leaveDayUserMap.get(item.id).hourtype | hourtypeIcon }} text-red"
                                [matTooltipShowDelay]="0"
                                matTooltip="{{ leaveDayUserMap.get(item.id)?.hourtype | hourtype }} - {{
                                    leaveDayUserMap.get(item.id)?.comment
                                }}"></i>
                        }
                        @if (blockedMap?.has(item.id)) {
                            <i
                                class="text-red fa-regular {{ blockedMap.get(item.id).icon }}"
                                [matTooltip]="blockedMap.get(item.id).description"
                                [matTooltipShowDelay]="0"></i>
                        }
                        {{ item.name }}
                        @if (item.default_stand == DefaultStand.Home) {
                            <i class="fa-duotone fa-house-user"></i>
                        }
                        @if (item.default_stand == DefaultStand.Geen) {
                            <i class="fa-duotone fa-xmark"></i>
                        }
                    </ng-template>
                </ng-select>
            </div>
        </td>
    }

    @if (pln.entity_id) {
        <td
            class="text-nowrap"
            [attr.colspan]="pln.entity | transportPlanningCols: pln.entitytype : pln.entity?.use_once"
            [class.error-background]="fg.controls.entity_id.invalid"
            [class.alert-multiple]="pln.entity_id | multiple: pln : planning : entitiesMap">
            @if (
                pln.entitytype?.key !== EntityTypeCode.Truck &&
                pln.entitytype?.key !== EntityTypeCode.CutterTruck &&
                pln.entitytype?.key !== EntityTypeCode.AsfaltTruck &&
                pln.entity?.use_once
            ) {
                <div class="material-piece" [matTooltip]="pln.name">
                    {{ pln.entity?.name ?? pln.hiring?.name ?? pln.name }}
                </div>
            }
            @if (
                (pln.entitytype_key === 'truck' ||
                    pln.entitytype_key === 'cutterTruck' ||
                    pln.entitytype_key === 'asfaltTruck') &&
                pln.entity?.use_once
            ) {
                <div class="d-flex">
                    <ng-select
                        [placeholder]="pln.name ?? 'Auto'"
                        [formControl]="fg.controls.entity_id"
                        [preventToggleOnRightClick]="true"
                        [clearable]="false">
                        <ng-template ng-label-tmp let-item="item">{{
                            (trucks | byId: item)?.name ?? item | licensePlate
                        }}</ng-template>
                        @for (truck of trucks; track truck) {
                            <ng-option
                                [value]="truck.id"
                                [innerHTML]="truck.name | materialPiece"
                                [disabled]="truck | entityUnavailable: pln : planning"></ng-option>
                        }
                    </ng-select>
                </div>
            }
            @if (!pln.entity?.use_once) {
                <div class="d-flex">
                    <ng-select
                        [formControl]="fg.controls.hiring_id"
                        [preventToggleOnRightClick]="true"
                        placeholder="Inhuurbedrijf {{ (entityTypes | byId: pln.entitytype_key)?.name }}">
                        @for (h of hiringMap.get(pln.entitytype_key); track h) {
                            <ng-option [value]="h.id" [innerHTML]="h.name"></ng-option>
                        }
                    </ng-select>
                </div>
            }
        </td>
    }
    @if (!pln.entity?.use_once && pln.entity_id) {
        <td class="text-input" [attr.colspan]="pln.entity | transportPlanningCols: pln.entitytype" width="150">
            <app-hire-name
                [fc]="fg.controls.name"
                [hiringAutocompleteOptions]="hiringAutocompleteOptions"></app-hire-name>
        </td>
    }
    @if (!pln.entity_id) {
        <td class="free-text">
            {{ pln.entitytype?.name }}
            <small> <br />{{ pln.type }} <br />nader te bepalen</small>
        </td>
    }
    @if (!pln.entity_id) {
        <td class="text-input" colspan="4">
            <input matInput placeholder="Nader te bepalen" type="text" formControlName="name" />
        </td>
    }
    @if (pln.entitytype?.has_truck && pln.entity_id) {
        <td
            [class.error-background]="fg.controls.truck_entity_id.invalid"
            [class.alert-multiple]="pln.truck_entity_id | multiple: pln : planning : entitiesMap">
            <div class="d-flex">
                <ng-select
                    [formControl]="fg.controls.truck_entity_id"
                    [preventToggleOnRightClick]="true"
                    [clearable]="false"
                    placeholder="Auto">
                    <ng-template ng-label-tmp let-item="item">{{
                        (trucks | byId: item)?.name ?? item | licensePlate
                    }}</ng-template>
                    @for (truck of trucks; track truck) {
                        <ng-option [value]="truck.id" [innerHTML]="truck.name"></ng-option>
                    }
                </ng-select>
            </div>
        </td>
    }
    @if (pln.entitytype?.has_lowloader && pln.entity_id) {
        <td
            [class.error-background]="fg.controls.lowloader_entity_id.invalid"
            [class.alert-multiple]="pln.lowloader_entity_id | multiple: pln : planning : entitiesMap">
            <div class="d-flex">
                <ng-select
                    [formControl]="fg.controls.lowloader_entity_id"
                    [clearable]="false"
                    [preventToggleOnRightClick]="true"
                    placeholder="Dieplader">
                    <ng-template ng-label-tmp let-item="item">{{
                        (lowLoaders | byId: item)?.name ?? item | licensePlate
                    }}</ng-template>
                    @for (lowloader of lowLoaders; track lowloader) {
                        <ng-option [value]="lowloader.id" [innerHTML]="lowloader.name"></ng-option>
                    }
                </ng-select>
            </div>
        </td>
    }
    <mat-menu #menu="matMenu" panelClass="context-menu">
        @if (!pln.entity_id) {
            <button (click)="changeEntity(pln, main, pln.id)" mat-menu-item>Kies materieel</button>
        }
        @if (pln.entity_id) {
            <button
                [disabled]="main.planning.planning_has_id === pln.id"
                (click)="removeEntity(main, pln.id)"
                mat-menu-item>
                {{
                    main.planning.planning_has_id === pln.id
                        ? 'Verwijder materieel via weekplanning'
                        : 'Verwijder materieel'
                }}
            </button>
        }
        <button (click)="duplicatePlanningExact(pln, main, fg)" mat-menu-item>Dupliceren</button>
        <button (click)="duplicatePlanning(pln, main, fg, true)" mat-menu-item>Voorgaand invoegen</button>
        <button (click)="duplicatePlanning(pln, main, fg)" mat-menu-item>Opvolgend invoegen</button>
        <button [disabled]="main.planning.planning_has_id === pln.id" (click)="deletePlanning(pln)" mat-menu-item>
            <i class="fa fa-trash"></i>
            {{ main.planning.planning_has_id === pln.id ? 'Verwijder via weekplanning' : 'Regel verwijderen' }}
        </button>
    </mat-menu>

    <ng-container formGroupName="date">
        <td class="tabletime" [class.error-background]="fg.errors && fg.errors.notAvailable" colspan="2">
            <div class="timepicker">
                <mat-select
                    [class.text-red]="fg.get('date').get('begintime')?.value | isNight"
                    formControlName="begintime"
                    placeholder="van"
                    panelWidth="200px">
                    <mat-select-trigger>
                        @if (fg.get('date').get('begintime')?.value | isSubsequent) {
                            <small>aansluitend {{ fg.get('date').get('begintime')?.value | date: 'HH:mm' }}</small>
                        } @else {
                            <small>{{ fg.get('date').get('begintime')?.value | date: 'EEE' }}</small>
                            {{ fg.get('date').get('begintime')?.value | date: 'HH:mm' }}
                        }
                    </mat-select-trigger>
                    <ng-container>
                        @for (day of startTimesEntity.get(pln); track day) {
                            <mat-optgroup label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                @for (time of day.options; track time) {
                                    <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                        @if (time.datetime | isSubsequent) {
                                            Aansluitend
                                        } @else {
                                            {{ time.datetime | date: 'HH:mm' }}
                                            <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                        }
                                    </mat-option>
                                }
                            </mat-optgroup>
                        }
                    </ng-container>
                </mat-select>
                <mat-select
                    [class.text-red]="fg.get('date').get('endtime')?.value | isNight"
                    formControlName="endtime"
                    placeholder="tot"
                    panelWidth="200px">
                    <mat-select-trigger>
                        @if (fg.get('date').get('endtime')?.value | isSubsequent) {
                            <small>aansluitend {{ fg.get('date').get('endtime')?.value | date: 'HH:mm' }}</small>
                        } @else {
                            <small>{{ fg.get('date').get('endtime')?.value | date: 'EEE' }}</small>
                            {{ fg.get('date').get('endtime')?.value | date: 'HH:mm' }}
                        }
                    </mat-select-trigger>
                    @if (endTimesEntity.has(pln)) {
                        @for (day of endTimesEntity.get(pln); track day) {
                            <mat-optgroup [label]="day.datetime | date: 'EEEE d MMM'">
                                @for (time of day.options; track time) {
                                    <mat-option [disabled]="time.notAvailable" [value]="time.time">
                                        {{ time.datetime | date: 'HH:mm' }}
                                        <small>{{ time.datetime | date: 'EEE d MMM' }}</small>
                                    </mat-option>
                                }
                            </mat-optgroup>
                        }
                    }
                </mat-select>
            </div>
        </td>
    </ng-container>
    @if (!readonly) {
        <td class="text-input">
            <span
                class="context-menu-trigger"
                #spanTrigger
                #menuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="menu"
                (menuOpened)="pln.selected = true"
                (menuClosed)="pln.selected = false"
                style="position: fixed"></span>
            <app-transport-address
                [main]="main"
                [planning]="pln"
                [fc]="fg.get('transport_origin')"
                [isOrigin]="true"
                [hasNext]="main.entities[i - 1]?.planning.driver_user_id === pln.driver_user_id && !!pln.driver_user_id"
                [fg]="fg"
                [users]="employees"
                placeholder="Startlocatie">
            </app-transport-address>
        </td>
    }
    <td class="text-input">
        <app-transport-address
            [main]="main"
            [planning]="pln"
            [fc]="fg.get('transport_worksite')"
            [fg]="fg"
            [users]="employees"
            placeholder="Werklocatie">
        </app-transport-address>
    </td>
    <td class="text-input">
        <app-transport-address
            [main]="main"
            [planning]="pln"
            [fc]="fg.get('transport_worksite_end')"
            [fg]="fg"
            [users]="employees"
            placeholder="Werklocatie">
        </app-transport-address>
    </td>
    @if (!readonly) {
        <td class="text-input">
            <app-transport-address
                [main]="main"
                [planning]="pln"
                [fc]="fg.get('transport_destination')"
                [fg]="fg"
                [hasNext]="main.entities[i + 1]?.planning.driver_user_id === pln.driver_user_id && !!pln.driver_user_id"
                [users]="employees"
                placeholder="Eindlocatie">
            </app-transport-address>
        </td>
    }
    <td class="text-input description" (click)="textArea.focus()">
        <textarea
            #textArea
            cdkTextareaAutosize
            placeholder="Omschrijving werkzaamheden"
            formControlName="comment"></textarea>
    </td>
    <td>
        <div class="d-flex">
            <ng-select
                [clearable]="true"
                [items]="executors"
                [placeholder]="environment.executorName | ucFirst"
                [preventToggleOnRightClick]="true"
                formControlName="performer_id"
                bindLabel="name"
                bindValue="id">
            </ng-select>
        </div>
    </td>
    @if (main.planning.is_transport) {
        <td>
            <div class="d-flex">
                <ng-select
                    [typeahead]="searchAfasProjects$"
                    [clearable]="true"
                    [selectableGroup]="false"
                    [items]="projects"
                    [preventToggleOnRightClick]="true"
                    formControlName="afas_project_id"
                    placeholder="Project"
                    groupBy="mainProject"
                    bindLabel="name"
                    bindValue="afas_project_id">
                    <ng-template ng-label-tmp let-item="item">
                        <b>{{ item.afas_project_id }}</b> {{ item.name }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <b>{{ item.afas_project_id }}</b> {{ item.name }}
                    </ng-template>
                </ng-select>
            </div>
        </td>
    }
</ng-container>
